import React from 'react';

import classNames from 'classnames';

import { SORT_DIRECTION } from '../../../types';

import ToggleDownIcon from './icons/toggle-down-icon.svg';
import ToggleUpIcon from './icons/toggle-up-icon.svg';

import './header-item.scss';

interface HeaderItemProps {
  alt?: string;
  title?: string;
  isSortable?: boolean;
  direction?: SORT_DIRECTION;
  onChangeSorting?: (direction: SORT_DIRECTION) => void;
}

export default function HeaderItem({
  alt = 't',
  onChangeSorting,
  direction,
  title = '',
  isSortable,
}: HeaderItemProps) {
  return (
    <div
      aria-hidden="true"
      onClick={() => {
        if (isSortable && onChangeSorting) {
          onChangeSorting(direction === 'ASC' ? 'DESC' : 'ASC');
        }
      }}
      className={classNames('table-header-item', {
        'table-header-item--hoverable': isSortable,
      })}
    >
      <div className="table-header-item__title">{title}</div>
      {isSortable && (
        <div className="table-header-item__toggle">
          <img
            src={direction === 'ASC' ? ToggleUpIcon : ToggleDownIcon}
            alt={alt}
          />
        </div>
      )}
    </div>
  );
}
